(() => {
'use strict';
const OFFER_END = Date.parse('2026-09-30T23:59:59+02:00');
const TOP_ATTR = 'data-ww-cro-top-ready';
let countdownTimer = null;
const isProductPage = () => /\/products\//.test(window.location.pathname);
const isEnglish = () => (document.documentElement.lang || '').toLowerCase().startsWith('en');
const tr = (es, en) => (isEnglish() ? en : es);
function productHandle() {
const marker = '/products/';
const path = window.location.pathname;
const index = path.indexOf(marker);
if (index === -1) return null;
return decodeURIComponent(path.slice(index + marker.length).split('/')[0] || '');
}
function rootPath() {
const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
return (root || '/').replace(/\/?$/, '/');
}
function findPrimaryCta() {
const selectors = [
'#MainContent .wcp-atc',
'#MainContent .w117-atc',
'#MainContent .bt-atc',
'#MainContent .wwpdp-atc',
'#MainContent .product-form__submit',
'#MainContent button[name="add"]',
'#MainContent [data-product-submit]',
'#MainContent [data-cta]'
];
const candidates = selectors.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
const unique = [...new Set(candidates)].filter((button) => button && !button.closest('cart-drawer'));
return unique.find((button) => {
const style = window.getComputedStyle(button);
const rect = button.getBoundingClientRect();
return style.display !== 'none' && style.visibility !== 'hidden' && rect.height >= 34;
}) || unique[0] || null;
}
function findBuybox(cta) {
return cta.closest('.wcp-buybox,.w117-buybox,.bt-buybox,.wwpdp-buybox,[data-ww-buybox]') ||
cta.closest('.wcp-card,.w117-card,.bt-box') ||
cta.closest('.product__info-container') ||
cta.closest('form') ||
cta.parentElement;
}
function findActionRow(cta) {
const known = cta.closest('.wcp-actions,.w117-actions,.bt-actions,.wwpdp-actions,.sd-actions,.product-form__buttons,[data-ww-actions]');
if (known) return known;
let node = cta.parentElement;
for (let depth = 0; node && depth < 3; depth += 1, node = node.parentElement) {
if (node.matches('form,.product__info-container,[data-ww-buybox]')) break;
const qty = node.querySelector('input[name="quantity"],input[type="number"]');
if (qty && node.contains(cta)) return node;
}
return cta;
}
function buildTop() {
const top = document.createElement('div');
top.className = 'ww-cro-top';
top.innerHTML = `
<div class="ww-cro-status">
<div class="ww-cro-proof" role="status">
<span class="ww-cro-proof__spark" aria-hidden="true">✦</span>
<strong>${tr('Más de 450 pedidos en WizzyWand', '450+ orders at WizzyWand')}</strong>
</div>
<div class="ww-cro-scarcity" data-ww-cro-scarcity hidden>
<span class="ww-cro-scarcity__dot" aria-hidden="true"></span>
<strong data-ww-cro-scarcity-text></strong>
</div>
</div>
`;
return top;
}
function nativeTrustMarkup() {
return isEnglish()
? '<span>🔒 Secure payment</span><span>📦 Free shipping + tracking</span><span>↩️ 90-day guarantee</span>'
: '<span>🔒 Pago seguro</span><span>📦 Envío gratis + seguimiento</span><span>↩️ 90 días de garantía</span>';
}
function normalizeText(value) {
return (value || '')
.toLowerCase()
.normalize('NFD')
.replace(/[\u0300-\u036f]/g, '')
.replace(/\s+/g, ' ')
.trim();
}
function findBestTextNode(root, phrases) {
const wanted = phrases.map(normalizeText);
const candidates = Array.from(root.querySelectorAll('span,p,div,li,strong,small'))
.filter((el) => !el.closest('.ww-trust-premium,.wcp-trust,.w117-trust,.bt-trust,.wwpdp-trust'))
.map((el) => ({ el, text: normalizeText(el.textContent) }))
.filter(({ text }) => text && text.length <= 130 && wanted.some((phrase) => text.includes(phrase)));
candidates.sort((a, b) => a.text.length - b.text.length);
return candidates.length ? candidates[0].el : null;
}
function rewriteExistingLowerRows(root) {
const paymentTarget = findBestTextNode(root, [
'recibiras exactamente el estilo seleccionado arriba',
'recibiras exactamente el modelo seleccionado arriba',
'you will receive exactly the style selected above',
'secure payment',
'pago seguro'
]);
const shippingTarget = findBestTextNode(root, [
'envio con seguimiento',
'tracked shipping'
]);
const returnsTarget = findBestTextNode(root, [
'devoluciones segun politica',
'returns according to policy'
]);
const targets = [paymentTarget, shippingTarget, returnsTarget];
const uniqueTargets = [...new Set(targets.filter(Boolean))];
if (uniqueTargets.length < 3) return false;
paymentTarget.textContent = tr('🔒 Pago seguro', '🔒 Secure payment');
shippingTarget.textContent = tr('📦 Envío gratis + seguimiento', '📦 Free shipping + tracking');
returnsTarget.textContent = tr('↩️ 30 días de garantía', '↩️ 30-day guarantee');
return true;
}
function placeTrustWhereItBelongs(scope) {
const root = scope && scope.querySelectorAll ? scope : document;
root.querySelectorAll('.ww-cro-risk').forEach((el) => el.remove());
const hasLowerRows = rewriteExistingLowerRows(root);
const knownBlocks = Array.from(root.querySelectorAll('.wcp-trust,.w117-trust,.bt-trust,.wwpdp-trust'));
if (hasLowerRows) {
knownBlocks.forEach((block) => block.remove());
root.querySelectorAll('.ww-trust-premium').forEach((block) => block.remove());
return;
}
knownBlocks.forEach((block) => {
block.classList.remove('ww-trust-premium');
block.classList.add('ww-trust-stack');
block.removeAttribute('data-ww-trust-ready');
const desired = nativeTrustMarkup();
const langKey = isEnglish() ? 'en' : 'es';
if (block.getAttribute('data-ww-native-trust') !== langKey || block.innerHTML !== desired) {
block.innerHTML = desired;
block.setAttribute('data-ww-native-trust', langKey);
}
block.style.setProperty('grid-template-columns', '1fr', 'important');
block.style.setProperty('display', 'grid', 'important');
});
root.querySelectorAll('.ww-trust-premium:not(.wcp-trust):not(.w117-trust):not(.bt-trust):not(.wwpdp-trust)')
.forEach((block) => block.remove());
}
function updateCountdowns() {
const diff = OFFER_END - Date.now();
document.querySelectorAll('[data-ww-cro-offer]').forEach((bar) => {
if (diff <= 0) {
bar.hidden = true;
return;
}
const totalSeconds = Math.max(0, Math.floor(diff / 1000));
const days = Math.floor(totalSeconds / 86400);
const hours = Math.floor((totalSeconds % 86400) / 3600);
const minutes = Math.floor((totalSeconds % 3600) / 60);
const seconds = totalSeconds % 60;
const timer = bar.querySelector('[data-ww-cro-countdown]');
if (!timer) return;
const hh = String(hours).padStart(2, '0');
const mm = String(minutes).padStart(2, '0');
const ss = String(seconds).padStart(2, '0');
const next = days > 0 ? `${days}d ${hh}:${mm}:${ss}` : `${hh}:${mm}:${ss}`;
if (timer.textContent !== next) timer.textContent = next;
timer.setAttribute('aria-label', tr('Tiempo restante de la oferta', 'Offer time remaining'));
});
}
async function hydrateScarcity(top) {
const box = top.querySelector('[data-ww-cro-scarcity]');
const text = top.querySelector('[data-ww-cro-scarcity-text]');
const handle = productHandle();
if (!box || !text || !handle) return;
try {
const response = await fetch(`${rootPath()}products/${encodeURIComponent(handle)}.js`, {
headers: { Accept: 'application/json' },
credentials: 'same-origin'
});
if (!response.ok) return;
const product = await response.json();
const variants = Array.isArray(product.variants) ? product.variants : [];
const soldOut = variants.filter((variant) => variant && variant.available === false).length;
if (!soldOut) {
box.hidden = true;
return;
}
if (variants.length <= 1) {
text.textContent = tr('Agotado temporalmente', 'Temporarily sold out');
} else if (soldOut === 1) {
text.textContent = tr(`1 modelo agotado de ${variants.length}`, `1 model sold out of ${variants.length}`);
} else {
text.textContent = tr(`${soldOut} modelos agotados de ${variants.length}`, `${soldOut} models sold out of ${variants.length}`);
}
box.hidden = false;
} catch (_) {
box.hidden = true;
}
}
function attachCro() {
if (!isProductPage()) return;
document.querySelectorAll('.ww-cro-top').forEach((el) => el.remove());
placeTrustWhereItBelongs(document);
}
function boot() {
if (!isProductPage()) return;
placeTrustWhereItBelongs(document);
attachCro();
updateCountdowns();
if (!countdownTimer) countdownTimer = window.setInterval(updateCountdowns, 1000);
window.setTimeout(attachCro, 250);
window.setTimeout(attachCro, 900);
const main = document.getElementById('MainContent');
if (main && !main.hasAttribute('data-ww-trust-observer')) {
main.setAttribute('data-ww-trust-observer', 'true');
const observer = new MutationObserver(() => {
placeTrustWhereItBelongs(main);
});
observer.observe(main, { childList: true, subtree: true });
}
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
else boot();
document.addEventListener('shopify:section:load', () => window.setTimeout(boot, 0));
})();
